/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ContractSignatureDocumentState = 'UNKNOWN' | 'REGISTERED' | 'SAVED' | 'SEND' | 'REFUSED_BY_PROCESSOR' | 'DELETED' | 'REJECTED' | 'SIGNED' | 'EXPIRED';

export const ContractSignatureDocumentState = {
    UNKNOWN: 'UNKNOWN' as ContractSignatureDocumentState,
    REGISTERED: 'REGISTERED' as ContractSignatureDocumentState,
    SAVED: 'SAVED' as ContractSignatureDocumentState,
    SEND: 'SEND' as ContractSignatureDocumentState,
    REFUSED_BY_PROCESSOR: 'REFUSED_BY_PROCESSOR' as ContractSignatureDocumentState,
    DELETED: 'DELETED' as ContractSignatureDocumentState,
    REJECTED: 'REJECTED' as ContractSignatureDocumentState,
    SIGNED: 'SIGNED' as ContractSignatureDocumentState,
    EXPIRED: 'EXPIRED' as ContractSignatureDocumentState
};

